import { Dices, Flame, ShoppingBag, Gamepad2, Heart } from 'lucide-react';
import { LegalLinks } from './LegalLinks';

const NAV_ITEMS = [
  { icon: Dices, label: "Dice", testId: "nav-dice" },
  { icon: Flame, label: "T or D", testId: "nav-tod" },
  { icon: ShoppingBag, label: "Shop", testId: "nav-shop" },
  { icon: Gamepad2, label: "Games", testId: "nav-games" },
  { icon: Heart, label: "Intimacy", testId: "nav-positions" },
];

export default function BottomNav({ activeTab, onTabChange }) {
  return (
    <div className="bottom-nav-bar">
    <nav className="flex items-stretch" data-testid="bottom-navigation" aria-label="Main navigation">
      {NAV_ITEMS.map(({ icon: Icon, label, testId }, index) => (
        <button
          key={testId}
          data-testid={testId}
          className={`nav-tab-item ${activeTab === index ? 'active' : ''}`}
          onClick={() => onTabChange(index)}
          aria-label={label}
          aria-current={activeTab === index ? 'page' : undefined}
        >
          <Icon
            size={20}
            strokeWidth={activeTab === index ? 2.2 : 1.8}
            color={activeTab === index ? '#F4436C' : '#B08EA0'}
          />
          <span className="nav-tab-label">{label}</span>
        </button>
      ))}
    </nav>
    <div className="px-2 pt-2 pb-1 border-t border-[#FFE0E8]">
      <LegalLinks prefix="navigation" compact />
    </div>
    </div>
  );
}
